import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

const StyledStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'start',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  '& .STAction': {
    minWidth: 'fit-content',
  },
}));

export default StyledStack;
